"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = void 0;
var snackbar_1 = require("@material/snackbar");
var Snackbar = (function () {
    function Snackbar() {
        var snackbarHtml = document.querySelector('.mdc-snackbar');
        if (snackbarHtml === null) {
            console.log('Snackbar component could not be initialized. Make sure the ict-notification-taghelper is included in the page.');
        }
        else {
            this._snackbar = new snackbar_1.MDCSnackbar(snackbarHtml);
            this._snackbarData = [];
        }
    }
    Snackbar.prototype.show = function (data) {
        if (this._snackbar === undefined || this._snackbarData === undefined) {
            return;
        }
        data.timeout = this.getSupportedTimeout(data.timeout);
        if (this._snackbarData.length == 0) {
            this._snackbar.timeoutMs = data.timeout;
            this._snackbar.labelText = data.message;
            this._snackbar.open();
            this.showNext(data.timeout);
        }
        this._snackbarData.push(data);
    };
    Object.defineProperty(Snackbar.prototype, "dismissesOnAction", {
        get: function () {
            if (this._snackbar === undefined || this._snackbarData === undefined) {
                return true;
            }
            return this._snackbar.dismissesOnAction;
        },
        set: function (value) {
            if (this._snackbar === undefined || this._snackbarData === undefined) {
                return;
            }
            this._snackbar.dismissesOnAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Snackbar.prototype.initialize = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this._snackbar === undefined || this._snackbarData === undefined) {
            return;
        }
        (_a = this._snackbar).initialize.apply(_a, args);
    };
    Snackbar.prototype.initialSyncWithDOM = function () {
        if (this._snackbar === undefined || this._snackbarData === undefined) {
            return;
        }
        this._snackbar.initialSyncWithDOM();
    };
    Snackbar.prototype.destroy = function () {
        if (this._snackbar === undefined || this._snackbarData === undefined) {
            return;
        }
        this._snackbar.destroy();
    };
    Snackbar.prototype.listen = function (evtType, handler) {
        if (this._snackbar === undefined || this._snackbarData === undefined) {
            return;
        }
        this._snackbar.listen(evtType, handler);
    };
    Snackbar.prototype.unlisten = function (evtType, handler) {
        if (this._snackbar === undefined || this._snackbarData === undefined) {
            return;
        }
        this._snackbar.unlisten(evtType, handler);
    };
    Snackbar.prototype.emit = function (evtType, evtData, shouldBubble) {
        if (this._snackbar === undefined || this._snackbarData === undefined) {
            return;
        }
        this._snackbar.emit(evtType, evtData, shouldBubble);
    };
    Snackbar.prototype.showNext = function (timeOut) {
        var _this = this;
        setTimeout(function () {
            if (_this._snackbar === undefined || _this._snackbarData === undefined) {
                return;
            }
            _this._snackbarData.shift();
            if (_this._snackbarData.length > 0) {
                var currentSnackbarData = _this._snackbarData[0];
                currentSnackbarData.timeout = _this.getSupportedTimeout(currentSnackbarData.timeout);
                _this._snackbar.timeoutMs = currentSnackbarData.timeout;
                _this._snackbar.labelText = currentSnackbarData.message;
                _this._snackbar.open();
                _this.showNext(currentSnackbarData.timeout);
            }
        }, timeOut);
    };
    Snackbar.prototype.getSupportedTimeout = function (timeout) {
        if (timeout === undefined) {
            return 4000;
        }
        else if (timeout > 10000) {
            return 10000;
        }
        return 4000;
    };
    return Snackbar;
}());
exports.Snackbar = Snackbar;
